<div #canvasContent>
  <button nz-button (click)="showModal()" nz-popover nzPopoverTitle="Action Details"
  [nzPopoverContent]="tasksTimelineTemplate" nzTooltipPlacement="bottomRight" style="background: blue; height: 60px;
  text-align: center;
  transform:rotate(45deg);
	width:60px;">
  <span style="transform:rotate(-45deg); color: white;">
    <!-- {{data.name}} -->
    <span nz-icon nzType="subnode" nzTheme="outline">
    </span>
  </span>
</button>
</div>
<ng-template #tasksTimelineTemplate>
  <nz-timeline class="p-20">
    <nz-timeline-item [nzDot]="timeWaitTemplate">
      Action Details
      <small class="d-b">
        Action Name: {{data.name}} 
      </small>
    </nz-timeline-item>
    <ng-container *ngIf="data && data.workflowEventMapping && data.workflowEventMapping.length > 0 && data.workflowEventMapping[0].eventType">
      <nz-timeline-item nzColor="green">
        Event Mapping
        <small class="d-b">
          <nz-form-item>
            <nz-table [nzData]="dataSet" [nzShowPagination]="false" style="min-width: 100%;">
              <thead>
                <tr>
                  <th>Event Type</th>
                  <th>Event Name</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let workflowEventMapping of data.workflowEventMapping;let i=index">
                  <td><span style="min-width: fit-content">{{workflowEventMapping.eventType}}</span>
                  </td>
                  <td><span style="min-width:fit-content">{{workflowEventMapping.eventName}}</span>
                  </td>
                </tr>
              </tbody>
            </nz-table>
        </nz-form-item>
        </small>
      </nz-timeline-item>
    </ng-container>
    <div class="footer-actions-bar">
      <div>
        <!-- Left -->
        <button nz-button [nzType]="'primary'" (click)="showModal()">Edit</button>
      </div>
      <div>
        <!-- Right -->
        <button nz-button [nzType]="'primary'" (click)="deleteStep(data.id)">Delete</button>
      </div>
    </div>
  </nz-timeline>
</ng-template>

<nz-modal [(nzVisible)]="isVisible" nzTitle="{{data.name}}" (nzOnCancel)="handleCancel()" (nzOnOk)="handleOk(data)"
  [nzOkLoading]="isOkLoading">
  <ng-container *nzModalContent>
    <form nz-form>
      <div class="form-secondary-fields">
        <nz-form-item>
          <nz-form-label [nzSpan]="24">Action Name</nz-form-label>
          <nz-form-control [nzSpan]="24">
            <input nz-input placeholder="Action Name" [(ngModel)]="stepName" name="input-basic" />
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
            <nz-table [nzData]="dataSet" [nzShowPagination]="false" style="min-width: 100%;">
              <thead>
                <tr>
                  <th>Event Type</th>
                  <th>Event Name</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let workflowEventMapping of data.workflowEventMapping;let i=index">
                  <td><nz-select nzShowSearch [(ngModel)]="workflowEventMapping.eventType" name="Event Type" style="min-width: 100%">
                    <nz-option *ngFor="let criteria of eventType" [nzLabel]="criteria" [nzValue]="criteria"></nz-option>
                  </nz-select></td>
                  <td><nz-select nzShowSearch [(ngModel)]="workflowEventMapping.eventName" name="Event Name" style="min-width: 100%">
                    <nz-option *ngFor="let criteria of eventName" [nzLabel]="criteria" [nzValue]="criteria"></nz-option>
                  </nz-select></td>
                  <td><span nz-icon nzType="delete" nzTheme="outline" (click)="removeMapping(i)"
                    ></span>
                    </td>
                </tr>
              </tbody>
            </nz-table>
          <button nz-button [nzType]="'primary'" (click)="addWorkflowMapping()">
            <i nz-icon nzType="plus" nzTheme="outline"></i>Add Mapping</button>
        </nz-form-item>
        <!-- <nz-form-item>
          <nz-form-label [nzSpan]="24">Category</nz-form-label>
          <nz-form-control [nzSpan]="24">
            <nz-radio-group nzName="radiogroup" [(ngModel)]="radioValue" name="radiogroup">
              <label nz-radio nzValue="A">Class XS</label>
              <label nz-radio nzValue="B">Class A</label>
              <label nz-radio nzValue="C">Class D</label>
              <label nz-radio nzValue="D">Class XE</label>
            </nz-radio-group>
          </nz-form-control>
        </nz-form-item> -->
      </div>
    </form>
    <!-- Rename Action :
    <input nz-input [(ngModel)]="stepName"/> -->
  </ng-container>
</nz-modal>